import PropTypes from 'prop-types';
import { List } from 'immutable';
import FunnelStageSelect from './FunnelStageSelect';
import GhostedCheckbox from './GhostedCheckbox';
import ProductInterestSelect from './ProductInterestSelect';
import PropertiesMetaRecord from '../records/PropertiesMetaRecord';
import PropertyUpdateErrorAlert from '../containers/PropertyUpdateErrorAlert';
import TierFitSelect from './TierFitSelect';
import PoweredByFooter from '../../shared/components/PoweredByFooter';
import ThreadRecord from '../records/ThreadRecord';
import { FUNNEL_STAGE, PRODUCT_INTEREST, TIER_FIT } from '../constants/ConversationsProperties';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const markAsGhostedPropDefault = () => {};
const threadPropertiesPropDefault = List();
const ConversationsTaxonomy = ({
  displayMode,
  markAsGhosted = markAsGhostedPropDefault,
  onPropertyChange,
  propertiesMeta,
  propertyUpdateStatus,
  threadRecord,
  threadProperties: __threadProperties = threadPropertiesPropDefault
}) => {
  var _propertyUpdateStatus;
  const isPanel = displayMode === 'panel';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [(propertyUpdateStatus === null || propertyUpdateStatus === void 0 ? void 0 : propertyUpdateStatus.hasPropertyUpdateError) && /*#__PURE__*/_jsx(PropertyUpdateErrorAlert, {}), /*#__PURE__*/_jsx(FunnelStageSelect, {
      allProperties: propertiesMeta.funnelOptions,
      currentValue: threadRecord.properties.get(FUNNEL_STAGE),
      "data-test-id": "funnel-stage-select",
      displayMode: displayMode,
      ghosted: isPanel && threadRecord.ghosted,
      onChange: onPropertyChange
    }), /*#__PURE__*/_jsx(ProductInterestSelect, {
      allProperties: propertiesMeta.productInterestOptions,
      currentValue: threadRecord.properties.get(PRODUCT_INTEREST),
      "data-test-id": "product-interest-select",
      displayMode: displayMode,
      ghosted: isPanel && threadRecord.ghosted,
      isUpdatingProperty: (_propertyUpdateStatus = propertyUpdateStatus === null || propertyUpdateStatus === void 0 ? void 0 : propertyUpdateStatus.isUpdatingProperty) !== null && _propertyUpdateStatus !== void 0 ? _propertyUpdateStatus : false,
      onChange: onPropertyChange,
      threadRecord: threadRecord
    }), /*#__PURE__*/_jsx(TierFitSelect, {
      allProperties: propertiesMeta.tierFitOptions,
      currentValue: threadRecord.properties.get(TIER_FIT),
      "data-test-id": "tier-fit-select",
      displayMode: displayMode,
      ghosted: isPanel && threadRecord.ghosted,
      onChange: onPropertyChange,
      threadRecord: threadRecord
    }), isPanel && /*#__PURE__*/_jsx(GhostedCheckbox, {
      isChecked: threadRecord.ghosted,
      onChange: markAsGhosted
    }), displayMode === 'card' && /*#__PURE__*/_jsx(PoweredByFooter, {})]
  });
};
ConversationsTaxonomy.propTypes = {
  displayMode: PropTypes.string.isRequired,
  markAsGhosted: PropTypes.func,
  onPropertyChange: PropTypes.func.isRequired,
  propertiesMeta: PropTypes.instanceOf(PropertiesMetaRecord).isRequired,
  propertyUpdateStatus: PropTypes.shape({
    hasPropertyUpdateError: PropTypes.bool.isRequired,
    isUpdatingProperty: PropTypes.bool.isRequired
  }),
  threadRecord: PropTypes.instanceOf(ThreadRecord).isRequired
};
export default ConversationsTaxonomy;